import { apiService } from './index';
import { TOKEN } from '../contexts/authContext';

export const asyncPostCaseClosure = (formdata: any) => {
    return apiService.post('/api/case-closure', formdata, undefined, {
        accept: '*/*',
        Authorization: 'Bearer ' + sessionStorage.getItem(TOKEN),
    });
};

export const asyncGetCasesClosures = async (
    page?: number,
    pageSize?: number,
    startDate?: any,
    endDate?: any,
    caseId?: string,
    status?: string
) => {
    return await apiService.get('/api/case-closure', {
        limit: pageSize || 20,
        page: page || 0,
        startDate: startDate || '',
        endDate: endDate || '',
        caseId: caseId || '',
        status: status || '',
    });
};

export const asyncDeleteErrorCases = async (
    startDate?: any,
    endDate?: any,
    caseId?: string
) => {
    const params: any = {};

    if (startDate && startDate !== '') {
        params.startDate = startDate;
    }

    if (endDate && endDate !== '') {
        params.endDate = endDate;
    }

    if (caseId && caseId !== '') {
        params.caseId = caseId;
    }

    return await apiService.delete('/api/case-closure/error-cases', params);
};
